import { createContext, useContext } from "react";

const ContactsContext = createContext<{
  setContactViewingId: (v: string | undefined) => void;
  setIsEditing: (v: boolean) => void;
}>({
  setContactViewingId: () => {},
  setIsEditing: () => {},
});

export const useSetContactView = () => {
  return useContext(ContactsContext);
};

export { ContactsContext };
